import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-register-tnc-dialog',
  templateUrl: './register-tnc-dialog.component.html',
  styleUrls: ['./register-tnc-dialog.component.css']
})
export class RegisterTncDialogComponent implements OnInit {
  @Input() data: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
